// extracted by mini-css-extract-plugin
export default {"wrapper":"search_wrapper__yiBqd","input":"search_input__9AFuA","clear":"search_clear__aeIa-"};